module.exports = __webpack_public_path__ + "img/card-5.3b4c886c.png";